
















































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import uuid from 'uuid/v4';
import { createPopper } from '@popperjs/core';

@Component({})
export default class NewSelectFieldWidget extends Vue {

  @Inject() public $validator: any;

  @Prop({ type: Array, default: () => [] }) public inputOptions!: any[];
  @Prop(String) public title!: string;
  @Prop(String) public inputName!: string;
  @Prop({ type: String, default: 'description' }) public displayField!: string;
  @Prop({ type: String, default: 'code' }) public valueField!: string;
  @Prop({ type: Boolean, default: true }) public selectOnTab!: boolean;
  @Prop(String) public staticInputId!: string;
  @Prop(String) public optionalText!: string;
  @Prop() public initialValue!: any;
  @Prop() public emptyOptionValueProp!: any;
  @Prop(Boolean) public isRequired!: boolean;
  @Prop(Boolean) public noDropdown!: boolean;
  @Prop(Boolean) public taggable!: boolean;
  @Prop(Boolean) public noEmptyOption!: boolean;
  @Prop(Boolean) public isDisabled!: boolean;
  @Prop(Boolean) public showWarningIcon!: boolean;
  @Prop(Boolean) public isSearchable!: boolean;
  @Prop(String) public reducerIndex!: string;
  @Prop(Boolean) public clearField!: boolean;
  @Prop(Boolean) public multiple!: boolean;
  @Prop(Boolean) public clearAble!: boolean;
  @Prop(Boolean) public emptyOptionStr!: string;
  @Prop({ type: Boolean, default: true }) public appendToBody!: string;
  @Prop({ type: String, default: 'payrollForm' }) public formName!: string;
  @Prop({ type: Function, default: option => option }) public reduce;

  private inputId: string = '';
  private htmlName: string = '';
  private inputModel: any = null;
  private inputOptionsModel: Array<any> = [];
  private emptyOptionValue: any = null;
  private placement: string = 'bottom';

  get validators(): any {
    if (this.isRequired) {
      return {
        required: true,
      };
    }
    return null;
  }

  public created() {
    this.inputModel = this.initialValue;
    this.inputOptionsModel = [...this.inputOptions];
    if (this.inputModel !== null) {
      this.$emit('input', this.inputModel);
    }
    this.emptyOptionValue = this.emptyOptionValueProp;
    this.inputId = this.staticInputId || 'input' + uuid();
    this.htmlName = this.inputName || this.$t(this.title).toString();
    if (this.formName && !this.staticInputId) {
      this.inputId = this.formName + '.' + this.inputId;
    }
  }

  public mounted() {
    this.initEmptyOption();
  }

  public onInput(e) {
    this.$emit('input', e);
  }

  @Watch('inputOptions')
  public onInputOptionsChanged() {
    this.inputOptionsModel = [...this.inputOptions];
    this.initEmptyOption();
  }

  @Watch('initialValue')
  public onInitialValueChanged() {
    this.inputModel = this.initialValue;
  }

  public withPopper(dropdownList, component, { width }) {
    /**
     * We need to explicitly define the dropdown width since
     * it is usually inherited from the parent with CSS.
     */
    dropdownList.style.width = width;

    /**
     * Here we position the dropdownList relative to the $refs.toggle Element.
     *
     * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
     * the dropdownList overlap by 1 pixel.
     *
     * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
     * wrapper so that we can set some styles for when the dropdown is placed
     * above.
     */
    const popperOptions: any = {
      placement: this.placement,
      modifiers: [
        {
          name: 'offset', options: {
            offset: [0, -1],
          },
        },
        {
          name: 'toggleClass',
          enabled: true,
          phase: 'write',
          fn({ state }) {
            component.$el.classList.toggle('drop-up', state.placement === 'top');
          },
        }],
    };
    const popper = createPopper(component.$refs.toggle, dropdownList, popperOptions);

    /**
     * To prevent memory leaks Popper needs to be destroyed.
     * If you return function, it will be called just before dropdown is removed from DOM.
     */
    return () => popper.destroy();
  }

  public initEmptyOption() {
    const emptyOption = {};
    if (this.noEmptyOption
        || (this.inputOptionsModel[0]
            && (this.inputOptionsModel[0][this.displayField] === ('' + this.$t('choose'))
                || (this.inputOptionsModel[0] && this.emptyOptionStr && this.inputOptionsModel[0][this.displayField] === ('' + this.$t(this.emptyOptionStr)))
                || this.inputOptionsModel[0][this.displayField] === ('' + this.$t('all'))))) {
      return;
    }
    if (!this.isRequired || this.emptyOptionStr) {
      emptyOption[this.displayField] = this.emptyOptionStr ? '' + this.$t(this.emptyOptionStr) : '' + this.$t('all');
      emptyOption[this.valueField] = this.emptyOptionValue;
      this.inputOptionsModel.unshift(emptyOption);
    }
  }

  public updateNull($event: any): void {
    this.inputModel = this.reducerIndex ? this.inputOptionsModel[0] ? this.inputOptionsModel[0][this.reducerIndex] : null
        : this.inputOptionsModel[0];
    this.$emit('input', this.inputModel);
  }

}
